import request from '@/utils/request'
import { login as loginMock, getInfo as getInfoMock } from './mock'
// 获取验证码
export function getCode() {
    return request('/captchaImage')
}

// 登录
export async function login(data) {
    // return request({
    //     url: '/login',
    //     method: 'post',
    //     data
    // })
    return await loginMock(data)
}

// 获取用户相关信息（基本信息、角色、权限）
export async function getInfo() {
    // return request('getInfo')
    return await getInfoMock()
}
